import { el } from 'redom';

import NavigableList from 'generics/components/navigable-list/native';
import OutsideClickEventRegistration from 'lib/outside-click-event-registration';

import {
  findIndexByPropertyValue
} from 'utilities/collection';

import {
  displayElementAroundAnchor
} from 'utilities/element-position';

import {
  getFontWeightOptions
} from './utilities';

import './index.scss';

class Label {

  constructor() {
    this.el = el('label.font-family-item.navigable-list-item', {
      class: 'ellipsis'
    });
  }

  update(option, index, options, context) {
    this.el.textContent = option.label;
  }

}

class FontWeightSelector {

  constructor(configuration) {

    this.fontWeight = configuration.fontWeight;
    this.onChange = configuration.onChange;
    this.onClose = configuration.onClose;
    this.outsideEventRegistration = null;

    const entries = NavigableList.toEntries(getFontWeightOptions(), 'value', 'name');

    this.valueIndex = findIndexByPropertyValue(entries, 'key', this.fontWeight);
    const selectedEntries = [];

    if (this.valueIndex !== -1) {
      selectedEntries.push(entries[this.valueIndex]);
    }

    this.list = new NavigableList({
      OptionEntry: Label,
      noScroll: true,
      onSelect: (item) => {
        this.onChange(item);
        this.onClose();
      },
      entries,
      selectedEntries
    });

    this.el = el('.font-weight-selector-main', [this.list]);

  }

  displayFontFamiliesMenu() {

    const element = this.el;
    const anchorElement = element.parentNode;
    const viewportElement = void 0;
    const verticalOffset = 10;
    const horizontalOffset = 0;
    const startSide = 'top';
    const placeOnCenter = true;
    const positionableSides = void 0;

    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);
    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);

  }

  onmount() {

    this.displayFontFamiliesMenu();

    this.outsideEventRegistration = new OutsideClickEventRegistration(this.el, this.onClose);

  }

  onunmount() {

    this.outsideEventRegistration.cancel();

  }

}

export default FontWeightSelector;